import { computed, ComputedRef, Ref, unref } from "vue"

export function useApplyDecisionMessageKeys(
  viewType: Ref<string>,
  prefix: Ref<string> | string,
  key: Ref<string> | string
): ComputedRef<string[]> {
  return computed(() => {
    const rawPrefix = unref(prefix)
    const rawKey = unref(key)

    return [
      `${rawPrefix}.${viewType.value}_${rawKey}`,
      `${rawPrefix}.${rawKey}`,
    ]
  })
}
